<template>
  <ul>
    <!--    eslint-disable-->
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in filteredItems"
      v-if="checkPermission(item.permission)"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import { mapGetters } from 'vuex'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import { isServiceTypeRateCardFeatureEnabled } from '@/helpers/serviceTypeFeature'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

const FinanceSettingsRepository = RepositoryFactory.get('financeSetting')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')
const ResourceRepository = RepositoryFactory.get('resource')

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: {
        commission_invoice: {
          rider_commission_invoice: {
            enabled: false,
          },
          agency_commission_invoice: {
            enabled: false,
          },
        },
      },
      serviceTypeFeatureEnabled: false,
    }
  },
  setup() {
    provide('openGroups', ref([]))
    return {
      resolveNavItemComponent,
    }
  },
  computed: {
    ...mapGetters(['permissions']),
    filteredItems() {
      return this.items.map(item => {
        if (item.title === 'Commissions') {
          // Only show the Commissions section if rider_commission_invoice or agency_commission_invoice is enabled
          if (this.form.commission_invoice.rider_commission_invoice.enabled || this.form.commission_invoice.agency_commission_invoice.enabled) {
            const filteredChildren = item.children.filter(child => {
              if (child.title === 'Rider') {
                return this.form.commission_invoice.rider_commission_invoice.enabled
              }
              if (child.title === 'Agent') {
                return this.form.commission_invoice.agency_commission_invoice.enabled
              }
              return true
            })
            return { ...item, children: filteredChildren }
          }
          return null
        }
        if (item.title === 'Rate Cards') {
          const filteredChildren = item.children.filter(child => {
            if (child.requiresServiceTypeFeature && !this.serviceTypeFeatureEnabled) {
              return false
            }
            return this.checkPermission(child.permission)
          })
          if (!filteredChildren.length) {
            return null
          }
          return { ...item, children: filteredChildren }
        }
        return item
      }).filter(Boolean)
    },
  },
  mounted() {
    this.readFinanceSetting()
    this.readServiceTypeFeature()
  },
  methods: {
    // eslint-disable-next-line consistent-return,no-unused-vars
    checkPermission(routePermissions) {
      if (this.permissions && routePermissions) {
        return this.permissions.some(i => routePermissions.includes(i))
      }
      return true
    },
    async readFinanceSetting() {
      try {
        const { data } = (await FinanceSettingsRepository.getFinanceSettingsResource()).data
        this.form = data
        localStorage.setItem('finance_setting', JSON.stringify(data))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readServiceTypeFeature() {
      let modules = []
      let orderSetting = {}
      let orderSettingCached = false
      try {
        modules = JSON.parse(localStorage.getItem('module_data') || '[]')
      } catch (e) {
        modules = []
      }
      try {
        const cachedOrderSetting = localStorage.getItem('order_setting')
        if (cachedOrderSetting) {
          orderSetting = JSON.parse(cachedOrderSetting) || {}
          orderSettingCached = Object.prototype.hasOwnProperty.call(orderSetting, 'service_type_rate_card')
        }
      } catch (e) {
        orderSetting = {}
      }
      this.serviceTypeFeatureEnabled = isServiceTypeRateCardFeatureEnabled(modules, orderSetting)

      try {
        const moduleRes = await ResourceRepository.getModules()
        const moduleBody = moduleRes && moduleRes.data
        let apiModules = modules
        if (Array.isArray(moduleBody)) {
          apiModules = moduleBody
        } else if (moduleBody && Array.isArray(moduleBody.data)) {
          apiModules = moduleBody.data
        }
        if (apiModules.length) {
          modules = apiModules
          localStorage.setItem('module_data', JSON.stringify(modules))
        }
      } catch (e) {
        // keep cached modules
      }

      if (!orderSettingCached) {
        try {
          const { data } = (await OrderSettingsRepository.getOrderSettingsResource()).data
          if (data) {
            orderSetting = data
            localStorage.setItem('order_setting', JSON.stringify(data))
          }
        } catch (e) {
          // keep cached order setting
        }
      }

      this.serviceTypeFeatureEnabled = isServiceTypeRateCardFeatureEnabled(modules, orderSetting)
    },
  },
}
</script>
